export enum BusinessTypeEnum {
  Company = 'company',
  Establishment = 'establishment',
}
